import { useTranslation } from "react-i18next";
import { LANGUES, appliquerLangue } from "@/i18n";

export default function LangueSwitcher({ sombre = false, onChange }) {
  const { i18n } = useTranslation();
  const active = i18n.language?.slice(0, 2) || "fr";
  return (
    <div className={`flex items-center rounded-lg border p-0.5 ${sombre ? "border-white/15 bg-white/5" : "border-[#E6DFD1] bg-white"}`}
         data-testid="selecteur-langue">
      {LANGUES.map((l) => (
        <button key={l.code} type="button"
                onClick={() => { appliquerLangue(l.code); onChange?.(l.code); }}
                data-testid={`langue-${l.code}`} aria-label={l.label}
                className={`h-8 px-2.5 rounded-md text-xs font-bold uppercase tracking-wide transition-colors ${
                  active === l.code
                    ? sombre ? "bg-[#D9A461] text-[#12100D]" : "bg-[#12100D] text-[#D9A461]"
                    : sombre ? "text-stone-400 hover:text-white" : "text-stone-500 hover:text-stone-800"
                }`}>
          {l.code}
        </button>
      ))}
    </div>
  );
}
